/**
 * Horizon Pro — Back to Top Button
 * Shows a button after scrolling past a configurable offset, smooth scrolls to top on click
 */
(function () {
  const btn = document.querySelector('.hp-back-to-top');
  if (!btn) return;

  const offset = parseInt(btn.closest('body')?.dataset?.backToTopOffset, 10) || 400;

  function toggleVisibility() {
    btn.classList.toggle('visible', window.scrollY > offset);
  }

  btn.addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });

  window.addEventListener('scroll', toggleVisibility, { passive: true });
  toggleVisibility();
})();
